import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import TraditionalEditorActions from '../common/TraditionalEditorActions';
import BottomControls from '../common/BottomControls';
//import { usePopup } from '../../context/PopupContext';
import { useResume } from '../../context/ResumeContext';
import { APP_DOMAIN, REVIEW_LANDINGPAGE_LINK, FINAL_RESUME, SECTION_INFO } from '../../constants/constants';
import ArrowUpDir from '../../assets/images/top-dir-arrow.svg';
import Splash from '../common/Splash';
import HeaderComponent from '../common/HeaderComponent';
import TemplateSelector from '../common/TemplateSelector';
import { circleColor, getResumeName, removeBodyScroll } from '../../helper';
import WpAPI from '../../WpApi';
import '../../assets/scss/app/blocks/reviews.scss';
import Resumes from '../resumetemplates/Resumes';
import { useResumePreviewSize } from '../common/useResumePreviewSize';
//const TemplateSelector = React.lazy(() => import('./TemplateSelector'));

const ResumeReviewLayout = (props) => {
    const history = useHistory();
    const [scale] = useResumePreviewSize();
    const [editIcon, setEditIcon] = useState(true);
    const [editResumeName, setEditResumeName] = useState(false);
    const [showTemplates, setShowTemplates] = useState(false);
    const [showBeforeUnload, setShowBeforeUnload] = useState(false);
    const {
        resume,
        showPreview, 
        setShowPreview,
        handlers
    } = useResume();
    //const popups = usePopup();
    // useEffect(() => {
    //     popups.configurePopup(POPUP_TYPES);
    // }, []);
    const getEditIcon = () => {
        return (editIcon && 
            <i className="icon-pencil" 
            onClick={(e) => {
                setEditIcon(false)
                setEditResumeName(true)
            }}></i>  
        )
    }
    const getEditInputBox = () => {
        return (editResumeName && 
            <input type="text" className="edit-input-field" name="resume_name" value={resume.resume_name}
                onChange={(e) => {
                    handlers.updateResumePreview({resume_name: e.target.value}, true)
                }}
                onBlur={(e) => {
                    setEditIcon(true)
                    setEditResumeName(false)
                }}
            />
        )
    }
    const closeOverLay = (e) => {
        if (e.target.className == 'right right__fullscreen') {
            setShowPreview(!showPreview);
            removeBodyScroll(false);
        }
        e.stopPropagation();
    }
  // Prompt message when leaving page
//   useEffect(() => {
//     function handleOnBeforeUnload(event){
//       event.preventDefault();
//       return (event.returnValue = '');
//     }
//     if(showBeforeUnload){
//         window.addEventListener("beforeunload", handleOnBeforeUnload);
//     } else {
//         window.removeEventListener("beforeunload", handleOnBeforeUnload);
//     }
//     return () => {
//       window.removeEventListener("beforeunload", handleOnBeforeUnload);
//     }
//   }, [])
    const scoreColor = circleColor(resume.resume_review?.resume_score.total_points);
    return (<>
        {props.hasOwnProperty('header') ? props.header : ''}
        { <>
            <HeaderComponent 
            editorType={ 'traditional'}
            saveResume={handlers.onsaveResume}
            resumeLoaded={true}
            showSplash={true}
            />
            <div className={`app-editor app-traditional`}>
                {props.leftPanel}
                <div className={`app-right-panel app-review-container inner ${props.editorType}`}>
                    <div className="editor-block">
                        <div className='reiview-resume-left-section'>
                                <div className="back-btn">
                                <Link to={REVIEW_LANDINGPAGE_LINK}><img src={`${APP_DOMAIN}/assets/images/left-arrow.svg`}/>
                                    Return to Resume Review Dashboard</Link> 
                                </div>

                                <div className='info-box'>
                                    <h2>Review Your {SECTION_INFO[props.section.id].label}</h2>
                                    <span>{SECTION_INFO[props.section.id] ? SECTION_INFO[props.section.id].desc : ''}</span>
                                    <span>Please review the suggestions in red to improve your resume.</span>
                                </div>
                                {props.left}
                        </div>
                        
                    </div>
                    <div className={`page-area ${props.editorType}-area`}>
                            <div className='reiview-resume-right-section'>
                                <div className='strength-box'>
                                        <span className={`score-btn ${resume.resume_review?.resume_score.total_points === 100 && 'min-size'}`} style={{'color':scoreColor,'borderColor':scoreColor}}>{ resume.resume_review?.resume_score.total_points}%</span>
                                        <span className='text-strength'>Power Score</span>
                                        <span className='text-draft'>{getResumeName(resume)}</span>
                                </div>
                                {props.right}
                            </div>
                    </div>

                    { showPreview && <div className="app-editor review">
                            <div id="rightEditor" className={showPreview ? `right right__fullscreen` : `right`} onClick={(e) => { 
                                closeOverLay(e);
                            }}>
                            {showPreview ? <div className="close-wrap" onClick={() => { setShowPreview(!showPreview), removeBodyScroll(false) }}>
                                <i>Close</i>
                            </div> : ''}
                            {showPreview && <div id="resume-download">
                                <div className="paper preview-resume" id="preview-resume">
                                    <div id="resume-page" className="page">
                                        {<Resumes data={resume}  scale={scale} no_dummy={true} />}
                                    </div>
                                </div>
                            </div> }
                        </div>
                    </div>}
                </div>
            </div>
        </>
        }
    </>);
}

export default ResumeReviewLayout;